var _mask, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAuthlogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 182,
    height: 48,
    viewBox: "0 0 182 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-1-outside-1_768_31166",
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 182,
    height: 48,
    fill: "black"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    width: 182,
    height: 48
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.00058 16.5537H10.8486L17.8275 1.3263H14.6533L9.43548 13.0079H9.392L4.19592 1.3263H1L8.00058 16.5537Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.6655 16.5537H37.4701V1.3263H34.6655V16.5537Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.7601 16.5537H58.5647V5.24192H58.6082L66.4567 16.5537H69.5221V1.3263H66.7176V12.6163H66.6741L58.8256 1.3263H55.7601V16.5537Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.3104 16.88C94.0716 16.88 96.9196 14.7482 97.5719 11.3111L94.876 10.6803C94.3977 13.0732 92.6584 14.3784 90.3104 14.3784C87.3101 14.3784 85.2013 12.1813 85.2013 8.94001C85.2013 5.69874 87.3101 3.47989 90.3104 3.47989C92.5714 3.47989 94.2672 4.69809 94.8542 6.87343L97.5284 6.19907C96.8109 3.02307 93.9846 1 90.3104 1C85.6796 1 82.3749 4.32828 82.3749 8.94001C82.3749 13.5517 85.6796 16.88 90.3104 16.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.047 16.5537H122.33V14.0521H113.851V9.96242H121.591V7.59129H113.851V3.80619H122.352V1.3263H111.047V16.5537Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.215 16.5537H141.02V5.24192H141.063L148.912 16.5537H151.977V1.3263H149.173V12.6163H149.129L141.281 1.3263H138.215V16.5537Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.591 16.5537H175.396V3.82795H180.94V1.3263H167.091V3.82795H172.591V16.5537Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.73985 47.1846C13.501 47.1846 16.3491 45.0528 17.0013 41.6157L14.3055 40.9849C13.8271 43.3778 12.0879 44.683 9.73985 44.683C6.73961 44.683 4.63074 42.4859 4.63074 39.2446C4.63074 36.0033 6.73961 33.7845 9.73985 33.7845C12.0009 33.7845 13.6967 35.0027 14.2837 37.178L16.9578 36.5037C16.2404 33.3277 13.4141 31.3046 9.73985 31.3046C5.10904 31.3046 1.80441 34.6329 1.80441 39.2446C1.80441 43.8563 5.10904 47.1846 9.73985 47.1846Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.7597 46.8583H44.8034L37.9333 31.6309H35.2374L28.3672 46.8583H31.411L32.5415 44.2261H40.6291L41.7597 46.8583ZM33.6068 41.768L36.5636 34.8722H36.6071L39.5638 41.768H33.6068Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.6077 46.8583H59.4123V41.3547H64.5214C67.8043 41.3547 70.0219 39.5274 70.0219 36.5037C70.0219 33.5017 67.7608 31.6309 64.5214 31.6309H56.6077V46.8583ZM59.4123 38.853V34.1108H64.391C66.2607 34.1108 67.2173 34.8504 67.2173 36.4819C67.2173 38.0482 66.152 38.853 64.391 38.853H59.4123Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.2616 46.8583H90.0661V31.6309H87.2616V46.8583Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.378 46.8583H117.183V34.1325H122.727V31.6309H108.878V34.1325H114.378V46.8583Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.171 46.8583H153.215L146.345 31.6309H143.649L136.779 46.8583H139.823L140.953 44.2261H149.041L150.171 46.8583ZM142.018 41.768L144.975 34.8722H145.019L147.975 41.768H142.018Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.933 46.8583H179.847V44.3567H171.737V31.6309H168.933V46.8583Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.00058 16.5537H10.8486L17.8275 1.3263H14.6533L9.43548 13.0079H9.392L4.19592 1.3263H1L8.00058 16.5537Z",
    fill: "#FBFBFB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M34.6655 16.5537H37.4701V1.3263H34.6655V16.5537Z",
    fill: "#FBFBFB"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M55.7601 16.5537H58.5647V5.24192H58.6082L66.4567 16.5537H69.5221V1.3263H66.7176V12.6163H66.6741L58.8256 1.3263H55.7601V16.5537Z",
    fill: "#FBFBFB"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M90.3104 16.88C94.0716 16.88 96.9196 14.7482 97.5719 11.3111L94.876 10.6803C94.3977 13.0732 92.6584 14.3784 90.3104 14.3784C87.3101 14.3784 85.2013 12.1813 85.2013 8.94001C85.2013 5.69874 87.3101 3.47989 90.3104 3.47989C92.5714 3.47989 94.2672 4.69809 94.8542 6.87343L97.5284 6.19907C96.8109 3.02307 93.9846 1 90.3104 1C85.6796 1 82.3749 4.32828 82.3749 8.94001C82.3749 13.5517 85.6796 16.88 90.3104 16.88Z",
    fill: "#FBFBFB"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M111.047 16.5537H122.33V14.0521H113.851V9.96242H121.591V7.59129H113.851V3.80619H122.352V1.3263H111.047V16.5537Z",
    fill: "#FBFBFB"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M138.215 16.5537H141.02V5.24192H141.063L148.912 16.5537H151.977V1.3263H149.173V12.6163H149.129L141.281 1.3263H138.215V16.5537Z",
    fill: "#FBFBFB"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M172.591 16.5537H175.396V3.82795H180.94V1.3263H167.091V3.82795H172.591V16.5537Z",
    fill: "#FBFBFB"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M9.73985 47.1846C13.501 47.1846 16.3491 45.0528 17.0013 41.6157L14.3055 40.9849C13.8271 43.3778 12.0879 44.683 9.73985 44.683C6.73961 44.683 4.63074 42.4859 4.63074 39.2446C4.63074 36.0033 6.73961 33.7845 9.73985 33.7845C12.0009 33.7845 13.6967 35.0027 14.2837 37.178L16.9578 36.5037C16.2404 33.3277 13.4141 31.3046 9.73985 31.3046C5.10904 31.3046 1.80441 34.6329 1.80441 39.2446C1.80441 43.8563 5.10904 47.1846 9.73985 47.1846Z",
    fill: "#FBFBFB"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M41.7597 46.8583H44.8034L37.9333 31.6309H35.2374L28.3672 46.8583H31.411L32.5415 44.2261H40.6291L41.7597 46.8583ZM33.6068 41.768L36.5636 34.8722H36.6071L39.5638 41.768H33.6068Z",
    fill: "#FBFBFB"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M56.6077 46.8583H59.4123V41.3547H64.5214C67.8043 41.3547 70.0219 39.5274 70.0219 36.5037C70.0219 33.5017 67.7608 31.6309 64.5214 31.6309H56.6077V46.8583ZM59.4123 38.853V34.1108H64.391C66.2607 34.1108 67.2173 34.8504 67.2173 36.4819C67.2173 38.0482 66.152 38.853 64.391 38.853H59.4123Z",
    fill: "#FBFBFB"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M87.2616 46.8583H90.0661V31.6309H87.2616V46.8583Z",
    fill: "#FBFBFB"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M114.378 46.8583H117.183V34.1325H122.727V31.6309H108.878V34.1325H114.378V46.8583Z",
    fill: "#FBFBFB"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M150.171 46.8583H153.215L146.345 31.6309H143.649L136.779 46.8583H139.823L140.953 44.2261H149.041L150.171 46.8583ZM142.018 41.768L144.975 34.8722H145.019L147.975 41.768H142.018Z",
    fill: "#FBFBFB"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M168.933 46.8583H179.847V44.3567H171.737V31.6309H168.933V46.8583Z",
    fill: "#FBFBFB"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M8.00058 16.5537H10.8486L17.8275 1.3263H14.6533L9.43548 13.0079H9.392L4.19592 1.3263H1L8.00058 16.5537Z",
    stroke: "#FBFBFB",
    strokeWidth: 1.24667,
    mask: "url(#path-1-outside-1_768_31166)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M34.6655 16.5537H37.4701V1.3263H34.6655V16.5537Z",
    stroke: "#FBFBFB",
    strokeWidth: 1.24667,
    mask: "url(#path-1-outside-1_768_31166)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M55.7601 16.5537H58.5647V5.24192H58.6082L66.4567 16.5537H69.5221V1.3263H66.7176V12.6163H66.6741L58.8256 1.3263H55.7601V16.5537Z",
    stroke: "#FBFBFB",
    strokeWidth: 1.24667,
    mask: "url(#path-1-outside-1_768_31166)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M90.3104 16.88C94.0716 16.88 96.9196 14.7482 97.5719 11.3111L94.876 10.6803C94.3977 13.0732 92.6584 14.3784 90.3104 14.3784C87.3101 14.3784 85.2013 12.1813 85.2013 8.94001C85.2013 5.69874 87.3101 3.47989 90.3104 3.47989C92.5714 3.47989 94.2672 4.69809 94.8542 6.87343L97.5284 6.19907C96.8109 3.02307 93.9846 1 90.3104 1C85.6796 1 82.3749 4.32828 82.3749 8.94001C82.3749 13.5517 85.6796 16.88 90.3104 16.88Z",
    stroke: "#FBFBFB",
    strokeWidth: 1.24667,
    mask: "url(#path-1-outside-1_768_31166)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M111.047 16.5537H122.33V14.0521H113.851V9.96242H121.591V7.59129H113.851V3.80619H122.352V1.3263H111.047V16.5537Z",
    stroke: "#FBFBFB",
    strokeWidth: 1.24667,
    mask: "url(#path-1-outside-1_768_31166)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M138.215 16.5537H141.02V5.24192H141.063L148.912 16.5537H151.977V1.3263H149.173V12.6163H149.129L141.281 1.3263H138.215V16.5537Z",
    stroke: "#FBFBFB",
    strokeWidth: 1.24667,
    mask: "url(#path-1-outside-1_768_31166)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M172.591 16.5537H175.396V3.82795H180.94V1.3263H167.091V3.82795H172.591V16.5537Z",
    stroke: "#FBFBFB",
    strokeWidth: 1.24667,
    mask: "url(#path-1-outside-1_768_31166)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M9.73985 47.1846C13.501 47.1846 16.3491 45.0528 17.0013 41.6157L14.3055 40.9849C13.8271 43.3778 12.0879 44.683 9.73985 44.683C6.73961 44.683 4.63074 42.4859 4.63074 39.2446C4.63074 36.0033 6.73961 33.7845 9.73985 33.7845C12.0009 33.7845 13.6967 35.0027 14.2837 37.178L16.9578 36.5037C16.2404 33.3277 13.4141 31.3046 9.73985 31.3046C5.10904 31.3046 1.80441 34.6329 1.80441 39.2446C1.80441 43.8563 5.10904 47.1846 9.73985 47.1846Z",
    stroke: "#FBFBFB",
    strokeWidth: 1.24667,
    mask: "url(#path-1-outside-1_768_31166)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M41.7597 46.8583H44.8034L37.9333 31.6309H35.2374L28.3672 46.8583H31.411L32.5415 44.2261H40.6291L41.7597 46.8583ZM33.6068 41.768L36.5636 34.8722H36.6071L39.5638 41.768H33.6068Z",
    stroke: "#FBFBFB",
    strokeWidth: 1.24667,
    mask: "url(#path-1-outside-1_768_31166)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M56.6077 46.8583H59.4123V41.3547H64.5214C67.8043 41.3547 70.0219 39.5274 70.0219 36.5037C70.0219 33.5017 67.7608 31.6309 64.5214 31.6309H56.6077V46.8583ZM59.4123 38.853V34.1108H64.391C66.2607 34.1108 67.2173 34.8504 67.2173 36.4819C67.2173 38.0482 66.152 38.853 64.391 38.853H59.4123Z",
    stroke: "#FBFBFB",
    strokeWidth: 1.24667,
    mask: "url(#path-1-outside-1_768_31166)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M87.2616 46.8583H90.0661V31.6309H87.2616V46.8583Z",
    stroke: "#FBFBFB",
    strokeWidth: 1.24667,
    mask: "url(#path-1-outside-1_768_31166)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M114.378 46.8583H117.183V34.1325H122.727V31.6309H108.878V34.1325H114.378V46.8583Z",
    stroke: "#FBFBFB",
    strokeWidth: 1.24667,
    mask: "url(#path-1-outside-1_768_31166)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M150.171 46.8583H153.215L146.345 31.6309H143.649L136.779 46.8583H139.823L140.953 44.2261H149.041L150.171 46.8583ZM142.018 41.768L144.975 34.8722H145.019L147.975 41.768H142.018Z",
    stroke: "#FBFBFB",
    strokeWidth: 1.24667,
    mask: "url(#path-1-outside-1_768_31166)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M168.933 46.8583H179.847V44.3567H171.737V31.6309H168.933V46.8583Z",
    stroke: "#FBFBFB",
    strokeWidth: 1.24667,
    mask: "url(#path-1-outside-1_768_31166)"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAuthlogo);
export default __webpack_public_path__ + "static/media/Auth.logo.ba20dac2d8a07b92f2ae6a9603d009c5.svg";
export { ForwardRef as ReactComponent };